<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 15,
      height: 15,
      color: 'currentColor',
      viewBoxValue: `0 0 15 15`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g clip-path="url(#clip0_825_2013)">
      <path
        d="M8.66662 4.66667L7.92292 3.17928C7.70888 2.7512 7.60186 2.53715 7.4422 2.38078C7.301 2.24249 7.13083 2.13732 6.944 2.07287C6.73273 2 6.49342 2 6.01481 2H3.46662C2.71988 2 2.34651 2 2.0613 2.14532C1.81041 2.27316 1.60644 2.47713 1.47861 2.72801C1.33328 3.01323 1.33328 3.3866 1.33328 4.13333V4.66667M1.33328 4.66667H11.4666C12.5867 4.66667 13.1468 4.66667 13.5746 4.88465C13.9509 5.0764 14.2569 5.38236 14.4486 5.75869C14.6666 6.18651 14.6666 6.74656 14.6666 7.86667V10.8C14.6666 11.9201 14.6666 12.4802 14.4486 12.908C14.2569 13.2843 13.9509 13.5903 13.5746 13.782C13.1468 14 12.5867 14 11.4666 14H4.53328C3.41318 14 2.85313 14 2.4253 13.782C2.04898 13.5903 1.74302 13.2843 1.55127 12.908C1.33328 12.4802 1.33328 11.9201 1.33328 10.8V4.66667Z"
        stroke="#667085"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_2013">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </IconBase>
</template>

<style scoped lang="scss"></style>
